import * as net from "../vipa/net";

export class Case {
    constructor() {
        $("#modal-variant")
            .on("click", "#variantModal-addToCart", this.click);
    }

    click = (event: JQuery.ClickEvent) => {
        let product_id = this.getProductId(event);
        let quantity = parseInt(
            (<HTMLInputElement>$("#variantModal-quantity")[0]).value
        );

        if (quantity < 1) {
            return
        }

        let data = {
            jsonrpc: "2.0",
            id: null,
            product_id: product_id,
            quantity: quantity
        }
        net.postJSON("/j/add-to-cart/", data, this.clickSuccess.bind(this))
            .fail(this.clickFail);
    }

    clickSuccess(response: JQuery.PlainObject): void {
        let cart_count = $("#base-cartCount");
        cart_count.text(response.result.cart_count);

        let modal = $("#modal-small");
        let content = $("#modal-small div");
        content.html(response.result.html);
        modal.foundation("open");
    }

    clickFail(response: JQuery.jqXHR): void {
        let modal = $("#modal-small");
        let content = $("#modal-small div");

        content.html(response.responseJSON.error);
        modal.foundation("open");
    }

    private getProductId(event: JQuery.ClickEvent): number {
        let product_id = parseInt(
            $(event.currentTarget)
                .closest(".product")
                .data("id")
        );
        return product_id
    }
}
